export const navigateToUrl = (url: string): void => {
  window.location.assign(url);
};
